import { Component } from '@angular/core';
import { SettingsActivitiesDocsOption } from 'src/app/enums/settings';
import { PermissionsService } from 'src/app/services/permissions.service';

@Component({
    selector: 'app-settings-activities-docs',
    templateUrl: './settings-activities-docs.component.html',
    styleUrls: ['./settings-activities-docs.component.scss']
})
export class SettingsActivitiesDocsComponent {
    readonly SettingsActivitiesDocsOption = SettingsActivitiesDocsOption;
    selectedComponent!: SettingsActivitiesDocsOption;

    componentMapping: Record<SettingsActivitiesDocsOption, string> = {
        [SettingsActivitiesDocsOption.DOCUMENT_STATUSES]: 'app-document-statuses',
        [SettingsActivitiesDocsOption.DOCUMENT_PRIORITIES]: 'app-document-priorities',
        [SettingsActivitiesDocsOption.DOCUMENT_CATEGORIES]: 'app-document-categories',
        [SettingsActivitiesDocsOption.DOCUMENT_TAGS]: 'app-document-tags',
        [SettingsActivitiesDocsOption.DOCUMENT_TYPE]: 'app-document-type',
        [SettingsActivitiesDocsOption.DOCUMENT_SECTIONS]: 'app-document-sections',
        [SettingsActivitiesDocsOption.EVENIMENT_GENEALOGIC_TYPE]: 'app-eveniment-genealogic',
        [SettingsActivitiesDocsOption.CONDITIE_MEDICALA_TYPE]: 'app-conditie-medicala',
    };

    componentKeys: string[] = Object.keys(this.componentMapping);

    onChange($event: { value: any }) {
        this.selectedComponent = $event.value;
    }

    selectedSection: any = null;

    constructor(private permissionsService: PermissionsService) {
        this.filterComponents();
    }

    filterComponents() {
        // if (!this.permissionsService.hasPermission('dgaspc.settings.document_statuses.list')) {
        //     this.componentKeys = this.componentKeys.filter(
        //         (item) => item !== SettingsActivitiesDocsOption.DOCUMENT_STATUSES
        //     );
        // }
        // if (!this.permissionsService.hasPermission('dgaspc.settings.document_priorities.list')) {
        //     this.componentKeys = this.componentKeys.filter(
        //         (item) => item !== SettingsActivitiesDocsOption.DOCUMENT_PRIORITIES
        //     );
        // }
        // if (!this.permissionsService.hasPermission('dgaspc.settings.document_categories.list')) {
        //     this.componentKeys = this.componentKeys.filter(
        //         (item) => item !== SettingsActivitiesDocsOption.DOCUMENT_CATEGORIES
        //     );
        // }
        // if (!this.permissionsService.hasPermission('dgaspc.settings.document_tags.list')) {
        //     this.componentKeys = this.componentKeys.filter(
        //         (item) => item !== SettingsActivitiesDocsOption.DOCUMENT_TAGS
        //     );
        // }
        // if (!this.permissionsService.hasPermission('dgaspc.settings.document_type.list')) {
        //     this.componentKeys = this.componentKeys.filter(
        //         (item) => item !== SettingsActivitiesDocsOption.DOCUMENT_TYPE
        //     );
        // }
        // if (!this.permissionsService.hasPermission('dgaspc.settings.document_sections.list')) {
        //     this.componentKeys = this.componentKeys.filter(
        //         (item) => item !== SettingsActivitiesDocsOption.DOCUMENT_SECTIONS
        //     );
        // }
        // if (!this.permissionsService.hasPermission('dgaspc.settings.status-programare.list')) {
        //     this.componentKeys = this.componentKeys.filter(
        //         (item) => item !== SettingsActivitiesOption.EVENIMENT_GENEALOGIC_TYPE
        //     );
        // }
        // if (!this.permissionsService.hasPermission('dgaspc.settings.status-programare.list')) {
        //     this.componentKeys = this.componentKeys.filter(
        //         (item) => item !== SettingsActivitiesOption.CONDITIE_MEDICALA_TYPE
        //     );
        // }
    }
}
